import React from 'react';

const ProductMoreDetails = ({ details }) => {
  if (!details || details.length === 0) {
    return null;
  }
  return (
    <div className="more-details-container">
      {details.map((item, index) => (
        <div key={item.image || index} className={`detail-row ${index % 2 !== 0 ? 'reverse' : ''}`}>
          <div className="detail-image">
            {/* --- Remove the backend URL --- */}
            <img src={item.image} alt={`Product detail ${index + 1}`} />
          </div>
          <div className="detail-text"><p>{item.text}</p></div>
        </div>
      ))}
    </div>
  );
};

export default ProductMoreDetails;